import React, {Component} from 'react';
import wnycLogo from './images/wnyc.svg';
import logo from './images/OBP_logo.svg';
import './vendor/font-awesome.min.css';
import './App.css';
import FontAwesome from 'react-fontawesome';
import fetchJsonp from 'fetch-jsonp';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      message: ''
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({value: event.target.value});
  }

  handleSubmit(event) {
    let url = 'https://nypublicradio.us5.list-manage.com/subscribe/post-json?u=4109fdd323aaac7078eadaa8f&id=86679dda8f&EMAIL=' + this.state.value;

    fetchJsonp(url, {jsonpCallback: 'c'}).then(response => response.json().then(data => {
      this.setState({message: data.msg});
      var noEmail = '0 - Please enter a value';
      if (data.msg === noEmail) {
        this.setState({ message: 'Whoops! You need to enter your email.' })
      }
    }
    ));
    event.preventDefault();
  }

  render() {
    return (
      <div className="page">
        <div className="background">

        <div className="box">

          <div className="box__top">
            <div className="hero">

           </div>

            <div className="box__header">
              <div className="box__logo">
                <img src={logo} alt="The Other Box Project logo"/>
              </div>
              <div className="box__title">
                <h2>The Other Box Project</h2>
                <h4>Love, Race & Identity: 1967-2017</h4>
              </div>
            </div>

            <div className="box__description">
              <p>The Other Box Project is a series of public conversations and museum installation curated by WNYC’s Jami Floyd. The project launched on the 50th anniversary of the Supreme Court’s <span className="text--italic">Loving v. Virginia</span> decision that forever changed the lives of interracial couples and allowed their children and grandchildren to express their identities in unprecedented ways. The project culminates with an exhibition of intimate portraits and op docs by the artist Carrie Mae Weems.</p>
            </div>

            {/*
            <div className="box__buttons">
            </div>
            */}

          </div>

          <div className="box__bottom">

            <div className="box__newsletter">
              <h3 className="text--large text--white">
                Stay Connected to Us
              </h3>

              <div className="mailchimp-form">
                <form onSubmit={this.handleSubmit}>
                  <label>
                    <input placeholder="Enter your email" type="email" value={this.state.value} onChange={this.handleChange}/>
                  </label>
                  <input type="submit" value="Sign up" className="clicked__obp__newsletter" />
                </form>
                <div className="box__newsletter--error clicked__obp__update-newsletter-profile" dangerouslySetInnerHTML={{ __html: this.state.message }}/></div>
              </div>

              <div className="box__footer">
                <a href="https://www.facebook.com/wnyc" target="_blank"
                   className="link--white clicked__obp__facebook">
                  <FontAwesome name='facebook'/>
                  Facebook
                </a>
                <a href="https://twitter.com/wnyc" target="_blank"
                   className="link--white clicked__obp__twitter">
                  <FontAwesome name='twitter'/>
                  Twitter
                </a>
              </div>
            </div>
          </div>

        </div>




        <div className="bg--dark">
          <div className="inner">
            <h3 className="text--large text--white nudge">
              Upcoming Events
            </h3>
            <h4 className="text--white">Black, White, Female, Other: Exploring Feminist Identity in this &#35;MeToo Moment</h4>
            <p className="text--white">March 15, 2018 at 7 PM in The Jerome L. Greene Space.</p>
            <a href="http://www.thegreenespace.org/events/thegreenespace/2018/mar/15/black-white-female-exploring-feminist-identity-metoo-moment/" className="btn btn--small buy__tickets__obp" target="_blank">Buy Tickets</a>
       
            <h4 className="text--white"> The Other Box Project | Stand Against Racism</h4>
            <p className="text--white">April 25, 2018 at <a href="https://www.lawrenceville.org/page" target="_blank">The Lawrenceville School</a>.</p>
      
            <h4 className="text--white"> Turn the Tables & Repair the World</h4>
            <p className="text--white">May 4, 2018 at <a href="https://www.jccmanhattan.org/communities/jccharlem/" target="_blank">JCC Harlem</a>.</p>

            <h4 className="text--white">The Other Box Project on Love, Race and Identity in Trump’s America</h4>
            <p className="text--white">June 6, 2018 at 7 PM in The Jerome L. Greene Space.</p>
            </div>
        </div>

{/*
        <div className="bg--social" href="http://google.com" target="_blank"
           title="Share your identity">
          <h3 className="text--large nudge text--white">
            Share your identity story
          </h3>
          <div className="nudge">Lorem Ipsum dolor #hashtag</div>
          <div className="box__footer">
                <a href="https://www.facebook.com/wnyc" target="_blank"
                   className="link--white">
                  <FontAwesome name='facebook'/>
                  Facebook
                </a>
                <a href="https://twitter.com/wnyc" target="_blank"
                   className="link--white">
                  <FontAwesome name='twitter'/>
                  Twitter
                </a>
          </div>
        </div>

*/}

        <div className="inner">

          <h3 className="text--large nudge text--black">More about the project</h3>
          <p>We all check boxes. For race, gender, marital status, and more. But until 2000, Americans were required to choose only one race on the U.S. Census form. And that meant a whole lot of us checked the “other” box. The Other Box Project is an exploration of multiracials, a community now growing three times faster than the general population. Mixed-race people are uniquely positioned to counter the rise in American nationalism through active engagement with people of all races, given their unique point of view on love, family and the new American identity. This dialogue will move away from divisiveness towards unity and equity. The conversation starts here.<br/>
          <a href="http://www.wnyc.org/story/introducing-other-box-project/" target="_blank">
            Listen to Jami Floyd and Brian Lehrer discuss the project &raquo;
          </a><br/>
          <a href="https://www.facebook.com/WNYC/videos/10154550093336080/" target="_blank">
            Watch Jami Floyd discuss The Other Box Project series of events &raquo;
          </a><br/>
        </p>
        </div>

        <div className="bg--gray">
          <div className="inner">
            <h3 className="text--large nudge text--black">Produced by</h3>
            <a href="http://www.wnyc.org/" target="_blank"><img className="wnyc__logo" src={wnycLogo} alt="WNYC logo"/></a>

            <h3 className="text--black">Conceived, created and curated by</h3>
            <p>Jami Floyd</p>

            <div className="copyright text--gray">&copy; 2017 <a href="http://www.wnyc.org/" target="_blank">WNYC</a></div>
          </div>
        </div>

      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js